<template
  ><div class="config-input-row">
    <span class="config-input-icon"><slot name="config_hang_input_img"/></span>
    <div class="config-input-field"><slot name="config_hang_input_left" /></div></div
></template>
<script>
export default { name: 'ConfigInputRow' }
</script>
<style scoped>
.config-input-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 60px;
  padding: 8px 0;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #eee;
  margin: 0;
  box-shadow: none;
}
.config-input-icon {
  display: flex;
  align-items: center;
  flex: none;
}
.config-input-icon ::v-deep img {
  width: 25px;
  height: 25px;
  object-fit: contain;
}
.config-input-field {
  flex: 1;
  min-width: 0;
}
.config-input-field ::v-deep input {
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  background: transparent;
  border: 0;
  color: #283444;
  font: inherit;
  line-height: 24px;
  padding: 10px 0;
}
.config-input-field ::v-deep input:disabled {
  color: #94a3b8;
}
.config-input-field ::v-deep input::placeholder {
  color: #9aa6b5;
  font-size: 14px;
}
</style>
